module.exports = __webpack_public_path__ + "static/media/independent_personality.5e22c1ae.svg";